import "./pageBanner.css";

const PageBanner = ({ title, bannerImage, altText }) => {
  return (
    <header className="pageBanner">
      <img className="bannerImage" src={bannerImage} alt={altText}></img>
      <div className="bannerContent">
        <h1>{title}</h1>
      </div>
    </header>
  );
};

export default PageBanner;
